import { Alert, AlertTitle } from '@mui/material'
import React from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import '../../src/pages/paymentPage.css';


const NoDataFound = (props) => {

    const { productData } = props;
    return (
        <Alert
            style={{ fontSize: '16px' }}
            severity="error"
            variant="outlined"
            icon={<ErrorOutlineIcon fontSize='large' />}
        >
            <AlertTitle style={{ fontSize: '20px' }}>Product not found.</AlertTitle>
            Kindly take a snapchat and send to our support team <a href={`mailto:support@stoxbox.in`}>support@bpwealth.com</a> or call on  +919152928550.
        </Alert>
    )
}

export default NoDataFound